// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { responseHandler } from '@/utils/networkUtils';

export const apiPost = (uri, payload = null) => http.post(uri, payload).then(responseHandler);
export const apiGet = (uri) => http.get(uri).then(responseHandler);